import { render } from "./LiquidationTransactions.vue?vue&type=template&id=5d274867"
import script from "./LiquidationTransactions.vue?vue&type=script&lang=js"
export * from "./LiquidationTransactions.vue?vue&type=script&lang=js"
script.render = render

export default script